<template>    
  <div class="background_basic">          
    <v-card class="ma-3" >            
      <v-toolbar dense flat color="white">      
        <v-toolbar-title class="grey--text text--darken-3">
          <v-icon class="mr-2">mdi-account-settings</v-icon>회사관리
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn color="blue" text @click="initialize()" class="font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">refresh</v-icon>초기화
        </v-btn>
        <v-btn color="blue" text @click="ExcelExpert('회사관리')" class = "ml-2 font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">mdi-microsoft-excel</v-icon>엑셀
        </v-btn>
        <v-spacer></v-spacer>
        
        <v-btn v-if="(UserInfo.CorpId=='NONE' || UserInfo.CorpId == 'SKMR')" color="blue" text @click="GetCorpMember()" class="font-weight-bold text-subtitle-1" :disabled="loading3">
          <v-icon big class="mr-2">mdi-cloud-download</v-icon>데이터불러오기
        </v-btn>
        
        <v-btn color="blue" text @click="ClearDialog(); isEditMode=false; dialog = true" class="font-weight-bold text-subtitle-1" :disabled="loading3">         
          <v-icon big class="mr-2">mdi-account</v-icon>신규등록
        </v-btn>
        <v-dialog v-model="dialog" max-width="600px">          
          <v-card ref="form">
            <v-card-title >
              <span class="font-weight-bold">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row class="ma-0">
                  
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cCorpId" label="회사코드" :disabled="isEditMode"></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="6">
                    <div class="d-flex">
                      <v-select class="mr-2" dense label="유형" :items="zDeviceTypeInfo" v-model="editedItem.cDeviceTypeId" item-value="sId" item-text="sNm" :disabled="isEditMode"></v-select>
                      <img height="30" :src="require('@/assets/Device/D'+editedItem.cDeviceTypeId+'.svg')"/> 
                    </div>
                  </v-col> -->
                  <!-- <v-col v-if="isEditMode" cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cCorpNm" label="업체명"></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6" md="6">
                    <v-select dense v-model="editedItem.cCorpId" class="mb-n5" label="업체" :items="zCorp" item-value="sId" item-text="sNm"></v-select>   
                  </v-col> -->
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cCorpNm" label="회사명"></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cTel" label="연락처"></v-text-field>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="6" md="6">
                    <eCalendar :sNowSelectDate="editedItem.cBirth" Caption="생년월일"  @onChaange="onCalChange"></eCalendar>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="6" md="6">
                    <v-select dense label="구분" :items="zUserRoleType" v-model="editedItem.cLev" item-value="sId" item-text="sNm"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select dense label="작업자구분" disabled :items="zWorkType" v-model="cWorkType"></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cUpdateUserId" label="최종수정자" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cUpdateDateTime" label="최종수정일" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cCreateUserId" label="최초생성자" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field dense v-model="editedItem.cCreateDateTime" label="최초생성일" disabled></v-text-field>
                  </v-col>                   -->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>                
              <v-spacer></v-spacer>              
              <v-btn color="blue darken-2" text @click="save" :disabled="loading" class="font-weight-bold text-subtitle-1">
                <v-icon big class="mr-2">save</v-icon>저장
              </v-btn>
              <v-btn color="grey darken-2" darken-2 text @click="close" :disabled="loading" class="font-weight-bold text-subtitle-1">
                <v-icon big class="mr-2">cancel</v-icon>취소
              </v-btn>              
            </v-card-actions>              
            <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom color="blue accent-4"></v-progress-linear>
          </v-card>
        </v-dialog>
        <v-progress-linear :active="loading3" :indeterminate="loading3" absolute bottom color="blue accent-4"></v-progress-linear>    
      </v-toolbar>
    
      <v-divider></v-divider>

      <v-card flat class="d-flex ml-3 mr-3">          
        <v-text-field
          v-model="cNowSearchKeyWord"
          class="ml-0 mb-n4"
          label="검색어"
          placeholder="업체 Id 또는 업체명 입력"
          persistent-placeholder
          style="max-width:220px;"
          Regular
          v-on:keyup.enter="Search()"
        ></v-text-field>
        <v-btn icon class="ml-n8 mt-3 text-subtitle-1" @click="Search()">
          <v-icon>search</v-icon>
        </v-btn>
      </v-card>
      <v-divider></v-divider>
      <v-data-table         
        :items-per-page="15" 
        fixed-header         
        height="calc(100vh - 250px)" 
        :headers="headers" 
        :items="Records"
        @dblclick:row="handleDoubleClick">
        <template v-slot:item.action="{ item }">
          <v-icon big class="mr-0" @click="editItem(item)">edit</v-icon>
          <v-icon big @click="deleteItem(item)">delete</v-icon>
          <!-- <v-icon big class="mr-0" @click="editItem(item)" :disabled="!ProgramPermissionInfo.okU">edit</v-icon>
          <v-icon big @click="deleteItem(item)" :disabled="!ProgramPermissionInfo.okD">delete</v-icon> -->
        </template>        
        <!-- <template v-slot:item.bUse="{ item }">
          <v-switch color="grey darken-3" v-model="item.bUse" class="mt-n2 mb-n7" @change="changeUse(item)"></v-switch>           
        </template>
        <template v-slot:item.bLocked="{ item }">
          <v-switch color="grey darken-3" v-model="item.bLocked" class="mt-n2 mb-n7" @change="changeLocked(item)"></v-switch>           
        </template>           -->


        <template v-slot:no-data>
          <p>No data available.</p>
        </template>
      
      </v-data-table>
    
    </v-card>
    <MsgBox ref="MsgBoxRef" @onMsgBox="onMsgBoxFunc" />    
    <!-- <GetSelMap ref="GetSelMapRef" @onGetMap="onGetMap" />        -->
  </div>    
</template>

<script>
import MsgBox from "@/components/MsgBox.vue";
// import eCalendar from "@/components/eCalendar.vue";
import BasicInfo from "../BasicInfo.js";
import Util from "../Util.js";
import axios from "axios";
import { mapState } from "vuex";
import XLSX from 'xlsx';
import EventBus from '@/eventBus.js';
// import GetSelMap from "@/components/GetSelMap.vue";


export default {
  components: {
    MsgBox,  
    // eCalendar,
    // GetSelMap,
  },
  data: () => ({
    bTagWith : false,
    isGroupALL : false,    
    cGroup : "ALL", 
    cNowSearchKeyWord : "",
    loading : false,
    loading3 : false,
    isEditMode : false,
    iDelIndex: 0,
    dialog: false,
    model : 0,
    sDate : "",        
    cWorkType : "작업자",    
    zWorkType : ["작업자"],
    // zPartNm: [{value:"P001", name:"개발팀"}, {value:"P002", name:"영업팀"}, {value:"P003", name:"총무팀"}, {value:"P004", name:"기획팀"}],  
    headers: [      
      // { title: '회사코드', key: 'cCorpId', align: 'center'},
      // { title: '회사이름', key: 'cCorpNm', align: 'center'},
      // { title: '작업', key: 'action', align: 'center', sortable: false,},

      { class: "font-weight-bold subtitle-2", text: "회사코드", value: "cCorpId",  },
      { class: "font-weight-bold subtitle-2", text: "회사명", value: "cCorpNm", align: "center"},   
      { class: "font-weight-bold subtitle-2", text: "작업", value: "action", align: "center", sortable: false},  
    ],
    
    Records: [],
    editedIndex: -1,
    // userId(스토어), cDel(golang), cEtc(golang)만 제외하고 테이블의 항목을 설정함 
    editedItem: {
      cCorpId: "",
      cCorpNm: "",      
      cDel: "N",
      // cCreateDateTime: "",
      // cUpdateDateTime: "",
    },
    deletedItem: {
      cCorpId: "",
      cCorpNm: "",      
      cDel: "N",
      // cCreateDateTime: "",
      // cUpdateDateTime: "",
    },
    defaultItem: {
      cCorpId: "",
      cCorpNm: "",      
      cDel: "N",
      // cCreateDateTime: "",
      // cUpdateDateTime: "",
    }
  }),

  computed: {
    ...mapState(["UserInfo", "CorpInfo", "ProgramPermissionInfo", "zUserRoleType", "zCorp", "zDeviceTypeInfoAll", "zDeviceTypeInfo"]),
    formTitle() {
      return this.editedIndex === -1 ? "신규 등록" : "항목 수정";
    },
  },

  created() {
    this.$store.state.GetCorpInfo();  

    this.initialize();
  },

  methods: {    
    // onCalChange(s){      
    //   this.editedItem.cBirth = s;      
    // },

    initialize() {
      this.cNowSearchKeyWord = "";      
      this.Search();
      this.model = 0;
    },

    ClearDialog() {      
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.cGroupId = this.$store.state.UserInfo.GroupId;

      // if (this.zCorp.length > 0){
      //   this.editedItem.cCorpId = this.zCorp[0].sId;
      //   this.editedItem.cCorpNm = this.zCorp[0].sNm;  
      // }      
      this.editedIndex = -1;                      
    },

    handleDoubleClick(value, items) { 
       if (!this.ProgramPermissionInfo.okU) return;
       this.editItem(items.item);  
    },

    // 장비등록 목록을 조회함. (검색어를 같이 보냄)
    Search() {
      this.loading = true;
      this.Records = [];
      var posData = {
        cNowSearchKeyWord : this.cNowSearchKeyWord,        
        cCorpId : this.UserInfo.CorpId,
        cCorpNm : this.UserInfo.CorpNm,
        cNowSiteId : this.UserInfo.NowSiteId,
      };

      // console.log("pos", posData)
      
      axios
        .post(BasicInfo.UIL_API + "GetCorp", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {       
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
             
          if (res.data.ResultCd === "00") {
            this.Records = res.data.Result;
            
            // for (var i = 0; i < this.Records.length; i++) {           
            //   this.Records[i].bLocked = this.Records[i].cLocked == 'Y';          
            //   this.Records[i].bUse = this.Records[i].cUse == "Y";         
            //   this.Records[i].zMap = res.data.Result[i].cMapCds.split(",");     
            // }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;  
          
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },

    
    save() {
      if (this.editedItem.cCorpId == "NONE" ) {
        EventBus.$emit("onShowMsg",true, "회사코드는 필수입력 항목입니다.");
        return;
      }     

      if (this.editedItem.cCorpNm == "" ) {
        EventBus.$emit("onShowMsg",true, "회사명은 필수입력 항목입니다.");
        return;
      }    
      
      
      var posData = {
        cNowSiteId : this.UserInfo.NowSiteId,                
        cCorpId: this.editedItem.cCorpId,            
        cCorpNm: this.editedItem.cCorpNm,            
        cNewCorpId: "",
        cEditCorpId: "",       
        cGroupId : this.editedItem.cGroupId,
        cDel: this.editedItem.cDel,
      }
      if (this.isEditMode) {
        posData.cEditCorpId = this.editedItem.cCorpId;
      } else {
        posData.cNewCorpId = this.editedItem.cCorpId;
      }

      this.loading = true;
      axios
        .post(BasicInfo.UIL_API + "SetCorp", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {
            if (this.isEditMode) {
              // this.editedItem.cApId = res.data.Result[0].cApId;
              // this.editedItem.cUpdateDateTime = res.data.Result[0].cUpdateDateTime;
              Object.assign(this.Records[this.editedIndex], this.editedItem);
            } else {
              // this.editedItem.cApId = res.data.Result[0].cApId;              
              // this.editedItem.cCreateDateTime = res.data.Result[0].cUpdateDateTime;
              // this.editedItem.cUpdateDateTime = res.data.Result[0].cUpdateDateTime;
              // this.editedItem.id = this.Records.length +1;     // 자동카운트시
              this.Records.push(this.editedItem);
            }
            this.dialog = false;
            EventBus.$emit("onShowMsg",false, "저장되었습니다.");

            this.Search();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },
    GetCorpMember() {
      var posData = {}
      
      this.loading3 = true;
      axios
        .post(BasicInfo.UIL_API + "GetCorpMember", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {        
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
            
          if (res.data.ResultCd === "00") {            
            EventBus.$emit("onShowMsg",false, "불러오기를 성공하였습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading3 = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading3 = false;
        });
    },

    changeUse(item){      
      //console.log("changeUse", item.cUserId, item.bUse);
      item.cUse = "N"
      if (item.bUse){ item.cUse = "Y" }
      
      var posData = {
        cNowSiteId : this.UserInfo.NowSiteId,
        cUserId : this.$store.state.UserInfo.UserId,
        cEditUserId : item.cUserId,
        cUse : item.cUse,
      }
      
      this.loading = true;
      axios
        .post(BasicInfo.UIL_API + "SetUserInfoUse", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {          
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {            
            EventBus.$emit("onShowMsg",false, "저장했습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },

    changeLocked(item){            
      item.cLocked = "N"
      if (item.bLocked){ item.cLocked = "Y" }
      
      var posData = {
        cNowSiteId : this.UserInfo.NowSiteId,
        cUserId : this.$store.state.UserInfo.UserId,
        cEditUserId : item.cUserId,
        cLocked : item.cLocked,
      }
      
      this.loading = true;
      axios
        .post(BasicInfo.UIL_API + "SetUserInfoLocked", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {          
          if (res.data.ResultCd === "00") {            
            EventBus.$emit("onShowMsg",false, "저장했습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },
    
    // 신규등록/수정 다이올로그 취소시 닫음 (0.3초가 지나면 디폴트값으로 넣어줌)
    close() {      
      this.dialog = false;
      this.isEditMode = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    // 수정 다이올로그 생성 (테이블상의 연필모양 클릭시, isEditMode는 수정못함)
    editItem(item) {
      this.isEditMode = true;
      this.editedIndex = this.Records.indexOf(item);   
      this.editedItem = Object.assign({}, item);       
      this.dialog = true;
    },

    // 삭제알람 다이올로그 띄우기 (클릭시 DB에 등록 진행: onMsgBoxFunc와 연동)
    deleteItem(item) {
      this.iDelIndex = this.Records.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.$refs.MsgBoxRef.RunMsgBoxShow(
        "확인",
        "삭제하시겠습니까? \r\n 삭제하시면 복원되지 않습니다. \r\n[" +
          this.deletedItem.cCorpId + "/" + this.deletedItem.cCorpNm + "]"
      );
    },

    // (deleteItem()와 연동) DB에서 삭제하기 (del='N'으로 바꿈), web 화면상에 iDelIndex로 부터 첫번째 행을 제거함
    // onMsgBox 값 (취소시:false, 저장시:true)
    onMsgBoxFunc: function(result) {
      if (result === true) {
        //삭제
        var posData = {
          cUserId: this.$store.state.UserInfo.UserId,
          cSiteId: this.$store.state.UserInfo.NowSiteId,
          cCorpId: this.deletedItem.cCorpId,
        };
        axios
          .post(BasicInfo.UIL_API + "DelCorp", posData, {
            headers: {
              Authorization: this.$store.state.UserInfo.Token
            }
          })
          .then(res => {
            if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
            if (res.data.ResultCd === "00") {
              this.Records.splice(this.iDelIndex, 1); 
            } else {
              EventBus.$emit("onShowMsg",true, res.data.Msg);
            }
          })
          .catch(err => {
            EventBus.$emit("onShowMsg",true, ""+err);
          });
      }
    },
    
    ExcelExpert(name){
      var r = Util.GetExcel(this.Records, this.headers);
      // var r = Util.GetExcel(this.Records, this.headers);
      var animalWS = XLSX.utils.json_to_sheet(r)       
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, animalWS, name) // sheetAName is name of Worksheet      
      XLSX.writeFile(wb, name + "-" + Util.sNowDate() + '.xlsx'); // name of the file is 'book.xlsx'
    },

    // GetMapItem(item) {
    //   this.isEditMode = true;
    //   this.editedIndex = this.Records.indexOf(item);   
    //   this.editedItem = Object.assign({}, item); 
    //   this.$refs.GetSelMapRef.show(this.editedItem.zMap); 
    // },

    onGetMap(zSelect, cMapNms, cMapCds) {
      this.editedItem.cMapCds = cMapCds;
      this.editedItem.cMapNms = cMapNms;
    
      var posData = {        
        cNowSiteId : this.UserInfo.NowSiteId,
        cUpdateUserId: this.$store.state.UserInfo.UserId,
        cUserId : this.editedItem.cUserId, 
        cMapCds : this.editedItem.cMapCds,
        cMapNms : this.editedItem.cMapNms,
      };

      
      console.log(zSelect);
      axios
        .post(BasicInfo.UIL_API + "SetUserMap", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {          
            Object.assign(this.Records[this.editedIndex], this.editedItem);
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },
  }
};
</script>

